<template>
  <div>
    <div class="container-fluid banner">
      <div class="container">
        <div class="row justify-content-md-center" v-if="leiloeiro">
          <div class="banner-leilao col-lg-3">
            <img v-if="leiloeiro.foto && leiloeiro.foto.url" :src="leiloeiro.foto.url"
              :title="leiloeiro.nomeComercial || leiloeiro.nome" class="foto" />
            <img v-else src="@/assets/images/sem_foto.png" alt="SEM FOTO" class="foto" />
          </div>
          <div class="banner-info col-lg-9">
            <div class="info-banner">
              <h3 class="pt-4 pb-2">{{ leiloeiro.nomeComercial || leiloeiro.nome }}</h3>
              <p class="titulo-descricao my-1" v-if="leiloeiro.razaoSocial">
                <strong>RAZÃO SOCIAL: </strong>{{ leiloeiro.razaoSocial }}
              </p>
              <p class="titulo-descricao my-1" v-if="leiloeiro.orgaoRegistro || leiloeiro.matricula">
                <strong>REGISTRO: </strong>
                {{ leiloeiro.orgaoRegistro }}<span v-if="leiloeiro.ufRegistro">/{{ leiloeiro.ufRegistro }}</span><span
                  v-if="leiloeiro.matricula"> - Matrícula {{ leiloeiro.matricula }}</span>
              </p>
              <p class="titulo-descricao my-1" v-if="leiloeiro.telefone">
                <strong>TELEFONE: </strong>{{ leiloeiro.telefone }}
              </p>
              <p class="titulo-descricao my-1" v-if="enderecoCompleto">
                <strong>ENDEREÇO: </strong>{{ enderecoCompleto }}
              </p>
            </div>
          </div>
        </div>
        <div class="row justify-content-md-center" v-else>
          <div class="col-12 text-center py-5">
            <h4 class="title" v-if="!loading">LEILOEIRO NÃO ENCONTRADO</h4>
            <h4 class="title" v-else>CARREGANDO...</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannerLeiloeiro',
  props: {
    leiloeiro: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      colorPrimary: process.env.VUE_APP_PRIMARY_COLOR,
      colorSecondary: process.env.VUE_APP_SECONDARY_COLOR,
      colorConstrast: process.env.VUE_APP_CONSTRAST_COLOR,
    };
  },
  computed: {
    enderecoCompleto() {
      const e = this.leiloeiro && this.leiloeiro.endereco;
      if (!e) return '';
      return [e.logradouro, e.numero, e.bairro, e.cidade, e.estado, e.cep].filter(Boolean).join(', ');
    },
  },
};
</script>

<style scoped>
.banner {
  background-color: v-bind(colorPrimary);
  margin-top: 88px;
  padding: 40px 0;
  box-shadow: 0px 5px 5px 0px rgb(0 0 0 / 45%);
}

.banner-leilao {
  display: flex;
  justify-content: center;
  align-items: center;
}

.banner-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  color: #fff;
}

.banner-info h3,
.banner-info h6,
.title {
  color: #fff;
}

.titulo-descricao {
  font-weight: 400;
  font-size: 0.9rem;
}

.auction-item-2 .auction-thumb {
  height: 200px;
  max-height: 200px;
  padding: 0;
  margin: 0;
  background-color: #fff;
  position: relative;
}

.auction-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.sem-foto {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-weight: bold;
}

.foto {
  width: 100%;
  position: relative;
  border-radius: 20px;
}

.title-adress {
  display: flex;
  align-items: center;
  text-align: center;
  height: 120px;
  background-color: v-bind(colorSecondary);
  border-radius: 0px 0px 20px 20px;
  justify-content: center;
  flex-direction: column;
  padding-top: 10px;
}

.title-adress p {
  color: #fff;
}

@media (max-width: 576px) {
  .banner {
    margin-top: 132px;
  }

  .titulo-descricao {
    font-size: 0.8rem;
    color: #c6c9d1f7;
  }
}
</style>
